import { STORE_API } from "api/ApiPath";
import {
  BaseApiResponseModel,
  Paging,
} from "api/baseApiResponseModel/BaseApiResponseModel";
import client from "api/client";

export type StoreListItem = {
  id?: string;
  name?: string;
  code?: string;
  type?: number;
  status?: number;
  address?: string;
  phone?: string;
  email?: string;
  userId?: string;
};

export type StoreListRequest = {
  code?: string;
  name?: string;
  user?: string; // staff phone
  status?: number;
  page?: number;
  limit?: number;
};

export type StoreRepository = {
  getStoreList(params: StoreListRequest): Promise<
    BaseApiResponseModel<{
      data: {
        items: StoreListItem[];
        pagination: Paging;
      };
    }>
  >;
};

class StoreImpl implements StoreRepository {
  async getStoreList(params: StoreListRequest): Promise<
    BaseApiResponseModel<{
      data: {
        items: StoreListItem[];
        pagination: Paging;
      };
    }>
  > {
    return await client.get(STORE_API.LIST, params);
  }
}

export const defaultStoreRepository = new StoreImpl();
